import { render, staticRenderFns } from "./CuentaDetalle.vue?vue&type=template&id=075206af"
import script from "./CuentaDetalle.vue?vue&type=script&lang=js"
export * from "./CuentaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports